import { render, staticRenderFns } from "./TruckEditSms.vue?vue&type=template&id=06a9fdc8&scoped=true&"
import script from "./TruckEditSms.vue?vue&type=script&lang=js&"
export * from "./TruckEditSms.vue?vue&type=script&lang=js&"
import style0 from "./TruckEditSms.vue?vue&type=style&index=0&id=06a9fdc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a9fdc8",
  null
  
)

export default component.exports